import { useSourceLanguage } from "../../i18n/LocalizedCopy";
import React, { useState } from "react";

const ARTWORK_PATH = `${process.env.PUBLIC_URL || ""}/images/welcome/welcome-cosmic-vault.webp`;

export default function WelcomeOfferArtwork() {
  useSourceLanguage();
  const [imageAvailable, setImageAvailable] = useState(true);

  return (
    <div className="welcome-offer-artwork" aria-hidden="true">
      <span className="welcome-offer-artwork__orbit welcome-offer-artwork__orbit--outer" />
      <span className="welcome-offer-artwork__orbit welcome-offer-artwork__orbit--inner" />
      <span className="welcome-offer-artwork__star welcome-offer-artwork__star--one" />
      <span className="welcome-offer-artwork__star welcome-offer-artwork__star--two" />
      <div className="welcome-offer-artwork__fallback">
        <span className="welcome-offer-artwork__vault-door">✦</span>
      </div>
      {imageAvailable ? (
        <img
          src={ARTWORK_PATH}
          alt=""
          decoding="async"
          onError={() => setImageAvailable(false)}
        />
      ) : null}
    </div>
  );
}
